<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="活动标题" prop="user">
              <a-input v-model="formInline.activityTitle" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="活动状态" prop="store">
              <a-select
                default-value="lucy"
                style="width: 120px"
                @change="handleChange"
                v-model="formInline.apply"
              >
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="0">关闭</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <eventManagementHomeContent
          ref="aaa"
          :formInline="formInline"
        ></eventManagementHomeContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import eventManagementHomeContent from "./eventManagementHomeContent.vue";
export default {
  components: {
    eventManagementHomeContent,
  },
  data() {
    return {
      formInline: {
        activityTitle: "",
        apply: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getManageList();
      this.formInline = {};
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/marketingManagement/eventManagement/eventManagementHome.vue